import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { supabaseEnabled } from '../config/supabase';

// Guard dla tras admina. Gdy Supabase Auth aktywne: wymaga sesji.
// Gdy Supabase nieskonfigurowane (legacy/dev): przepuszcza - stary tryb bez auth.
const RequireAdmin: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { session, loading, kind } = useAuth();
  const location = useLocation();

  if (!supabaseEnabled) return <>{children}</>;

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <div className="spinner" />
      </div>
    );
  }

  if (!session || kind !== 'admin') {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
};

export default RequireAdmin;
